import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { GetPostFeedAPI } from 'api/community';
import { SubHeaderOptions } from 'constants/index';
import SubHeader from 'components/common/SubHeader';
import { communityActions } from 'store/community';
import SpaceFeedDetailService from 'components/branch/_post_detail';

var SpaceFeed = function SpaceFeed(_ref) {
  var error = _ref.error;

  if (error) {
    return null;
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SubHeader, {
      options: SubHeaderOptions,
      selected: "\uC18C\uC2DD"
    }), /*#__PURE__*/_jsx(SpaceFeedDetailService, {})]
  });
};

SpaceFeed.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var query, store, id, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref2.query, store = _ref2.store;
            id = query.id;
            _context.next = 4;
            return GetPostFeedAPI(id);

          case 4:
            response = _context.sent;

            if (!(response.status >= 400)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", {
              error: true
            });

          case 7:
            store.dispatch(communityActions.setBranchPost(response.data));
            return _context.abrupt("return", {
              error: false
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

export default SpaceFeed;